package fr.frux.navigation

import fr.frux.core.designsystem.components.NavigationBackInterceptors

/**
 * Retour système de la pile : une surcouche ou un écran qui a enregistré un intercepteur (feuille,
 * dialogue de sortie de l'assistant) le consomme d'abord, sinon on dépile. Sans cela, le retour
 * Android quitterait l'assistant en perdant la saisie.
 */
internal fun handleNavBack(
    interceptors: NavigationBackInterceptors?,
    navigationState: NavigationState,
) {
    if (interceptors?.dispatchBack() == true) return
    navigationState.navigateBack()
}
